const requireSelect = { required: true, message: '请选择' };
// 邮箱格式校验
const validateEmail = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val && !emailReg.test(val)) {
    callback(new Error('请输入正确邮箱'));
  }
  callback();
};
// 邮箱格式校验(已存在邮箱后缀)
const validateEmail2 = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val !== '' && !emailReg.test(`${val}@chailease.com.cn`)) {
    callback(new Error('请输入正确邮箱'));
  }
  callback();
};
// 金额校验 仅整数，大于0
const validateMoney = (rule, val, callback) => {
  const numReg = /^\d+$/;
  if ((val || val === 0) && !numReg.test(val)) {
    callback(new Error('请输入大于0的整数数字'));
  }
  callback();
};
// // 手机号校验
// export const validatePhone = (rule, val, callback) => {
//   // const phoneReg = /^\d+$/;
//   if (val !== "" && !numReg.test(val)) {
//     callback(new Error("请输入正确的手机号"));
//   }
//   callback();
// };
// 座机号校验
const validateTel = (rule, val, callback) => {
  const telReg = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/;
  if (val !== '' && !telReg.test(val)) {
    callback(new Error('请输入正确的电话号码'));
  }
  callback();
};
// 身份证号校验
export const validateIdentityId = (rule, val, callback) => {
  const numReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
  if (val !== '' && !numReg.test(val)) {
    callback(new Error('请输入正确的身份证号码'));
  }
  callback();
};
// 港澳台通行证校验
export const validateExitEntryPermit = (rule, val, callback) => {
  const numReg = /(^8)([A-Za-z0-9]{17}$)/;
  if (val !== '' && !numReg.test(val)) {
    callback(new Error('请输入正确的通行证号码'));
  }
  callback();
};
// 护照校验
export const validatePassport = (rule, val, callback) => {
  const numReg = /^[a-zA-Z0-9]{8,15}$/;
  if (val !== '' && !numReg.test(val)) {
    callback(new Error('请输入正确的护照号码'));
  }
  callback();
};
// 税号校验
const validateTaxNumber = (rule, val, callback) => {
  const numReg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]{1}$/;
  const taxReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (val !== '' && !numReg.test(val) && !taxReg.test(val)) {
    callback(new Error('客户名称为企业，请输入正确的税号'));
  }
  callback();
};
// 税号校验
const validateTaxNumber2 = (rule, val, callback) => {
  const numReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (val !== '' && !numReg.test(val)) {
    callback(new Error('请输入正确的纳税人识别号'));
  }
  callback();
};
// 证件号校验
const validateIdNumber = (rule, val, callback) => {
  const identityIdReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  const permitReg = /(^8)([A-Za-z0-9]{17}$)/;
  const passpotReg = /^[a-zA-Z0-9]{8,15}$/;
  const numReg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]{1}$/; // 组织机构代码
  const taxReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (val !== '' && !identityIdReg.test(val) && !permitReg.test(val) && !passpotReg.test(val) && !numReg.test(val) && !taxReg.test(val)) {
    callback(new Error('请输入正确的证件号'));
  }
  callback();
};
// 银行卡号（10到30位, 覆盖对公/私账户, 参考微信支付）
// export const validateAccount = (rule, val, callback) => {
//   const accountReg = /^[0-9]\d{9,29}$/;
//   if (val !== "" && !accountReg.test(val)) {
//     callback(new Error("请输入正确的开户行账号"));
//   }
//   callback();
// };
// 员工编号长度限制
const validatemenberNum = (rule, val, callback) => {
  const accountReg = /^.{0,19}$/;
  if (val !== '' && !accountReg.test(val)) {
    callback(new Error('请输入20位以内员工编号'));
  }
  callback();
};
// 邮寄地址校验
const validateSendAddress = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val && emailReg.test(val)) {
    callback(new Error('邮寄地址请勿输入邮箱地址'));
  }
  callback();
};
// 校验存在数字
const validExitNumber = (rule, val, callback) => {
  let reg = /\d/g;
  if (val !== '' && reg.test(val)) {
    callback(new Error('请勿输入数字'));
  }
  callback();
};

export const REQUIRERULE = {
  selectRequire: { rules: [requireSelect] },
  wenEmail: {
    rules: [
      { required: true, message: '请输入文审邮箱' },
      {
        validator: validateEmail2
      }
    ]
  },
  receiveEmail: {
    rules: [
      { required: true, message: '请输入接收保单邮箱' },
      {
        validator: validateEmail
      }
    ]
  },
  yeEmail: {
    rules: [
      { required: true, message: '请输入业务员邮箱' },
      {
        validator: validateEmail2
      }
    ]
  },
  menberNum: {
    rules: [
      { required: true, message: '请输入员工编号' },
      {
        validator: validatemenberNum
      }
    ]
  },
  holderName: {
    rules: [{ required: true, message: '请输入客户名称' }]
  },
  taxIdNumber: {
    rules: [
      { required: true, message: '请输入税号/证件号' },
      {
        validator: validateTaxNumber
      }
    ]
  },
  idNumber: {
    rules: [{ required: true, message: '请输入税号/证件号' }, { validator: validateIdNumber }]
  },
  tickets: {
    rules: [{ required: true, message: '请输入汇款金额' }, { validator: validateMoney }]
  },
  invoiceStart: {
    rules: [{ required: true, message: '请选择发票抬头' }]
  },
  invoiceSbh: {
    rules: [
      { required: true, message: '请输入纳税人识别号' },
      {
        validator: validateTaxNumber2
      }
    ]
  },
  invoiceKhh: {
    rules: [{ required: true, message: '请输入开户行名称' }]
  },
  invoiceNumber: {
    rules: [
      { required: true, message: '请输入开户行账号' }
      // { validator: validateAccount },
    ]
  },
  invoiceKpdz: {
    rules: [{ required: true, message: '请输入开票地址' }]
  },
  invoiceKpdh: {
    rules: [{ required: true, message: '请输入开票电话' }]
  },
  invoiceLxr: {
    rules: [{ required: true, message: '请输入联系人' }, { validator: validExitNumber }]
  },
  invoiceLxdh: {
    rules: [{ required: true, message: '请输入联系人手机号' }, { validator: validateTel }]
  },
  invoiceYjdz: {
    rules: [{ required: true, message: '请输入邮寄地址' }, { validator: validateSendAddress }]
  },
  industrycode: {
    rules: [{ required: true, message: '请选择行业名称' }]
  },
};
export function rentMoney(name) {
  const message = `请输入${name}`;
  return {
    rules: [{ required: true, message }, { validator: validateMoney }]
  };
}
export const CAICHANRULE = {};
export const CHENGZURULE = {
  identity: []
};
export const industryList = [
  { value: 'B1', text: '纺纱业', character: 'B1303', characterName: '纺纱厂（使用棉、麻、人造纤维）' },
  { value: 'B2', text: '织布业', character: 'B1306', characterName: '织布厂' },
  { value: 'B3', text: '不织布与其它纺织品制造业', character: 'B1313', characterName: '不织布制造厂' },
  { value: 'B4', text: '印染整理业', character: 'B1308', characterName: '印花、染色、定型、漂洗厂' },
  { value: 'B5', text: '纺织制品制造业', character: 'B1307', characterName: '针织厂、织带厂、织袜厂' },
  { value: 'B6', text: '金属模具及结构组件制造业', character: 'B0601', characterName: '金属材料及制品加工厂（无涂装工作）' },
  { value: 'B7', text: '金属加工处理业', character: 'B0601', characterName: '金属材料及制品加工厂（无涂装工作）' },
  { value: 'B8', text: '其它金属制品制造业', character: 'B0616', characterName: '合金材料厂' },
  { value: 'B9', text: '钢铁制造业', character: 'B0603', characterName: '金属冶炼、铸锻、压延、轧制厂' },
  { value: 'B10', text: '铝制造业', character: 'B0623', characterName: '铝铸件厂' },
  { value: 'B11', text: '其它基本金属制造业', character: 'B0603', characterName: '金属冶炼、铸锻、压延、轧制厂' },
  { value: 'B12', text: '服饰及皮革制品制造业', character: 'B1321', characterName: '制衣、帽厂' },
  { value: 'B13', text: '纸浆、纸及纸制品制造业', character: 'B0903', characterName: '纸制品综合加工厂（色纸、纸板、纸箱、纸筋、纸绳）' },
  { value: 'B14', text: '印刷及数据储存媒体复制业', character: 'B0907', characterName: '印刷厂' },
  { value: 'B15', text: '化学材料制品制造业', character: 'B0101', characterName: '化学工厂（原料为普通品、成品为普通品）' },
  { value: 'B16', text: '药品制造业', character: 'B1902', characterName: '西药厂（合成、调制）' },
  { value: 'B17', text: '石油及煤制品制造业', character: 'B0113', characterName: '石油炼解厂' },
  { value: 'B18', text: '塑料、橡胶制品制造业', character: 'B1001', characterName: '橡胶制品厂' },
  { value: 'B19', text: '非金属矿物制品制造业', character: 'B1804', characterName: '石开采厂' },
  { value: 'B20', text: '半导体制造业', character: 'B1110', characterName: '半导体材料、设备厂' },
  { value: 'B21', text: '印刷电路板制造业', character: 'B1129', characterName: '印刷电路板厂' },
  { value: 'B22', text: '光学及被动电子零组件制造业', character: 'B1133', characterName: '光学元件厂' },
  { value: 'B23', text: '其它电子零组件制造业', character: 'B1124', characterName: '电子元件制造厂（电阻、电容以外）' },
  { value: 'B24', text: '计算机及其外围设备制造业', character: 'B1125', characterName: '电子元件装配厂（仪器、电脑、手机、周边）' },
  { value: 'B25', text: '电子及通信及光学制品制造业', character: 'B1125', characterName: '电子元件装配厂（仪器、电脑、手机、周边）' },
  { value: 'B26', text: '电力设备制造业', character: 'B1212', characterName: '电力变压器制造厂' },
  { value: 'B27', text: '机械设备制造业', character: 'B0501', characterName: '机械设备及其零件制造修理厂' },
  { value: 'B28', text: '汽车及其零件制造业', character: 'B1402', characterName: '机动车辆、飞机及零件制造修配厂（塑料除外）' },
  { value: 'B29', text: '其它运输工具制造业', character: 'B1405', characterName: '车辆修理厂（钣金、喷烤漆）' },
  { value: 'B30', text: '食品及饮料制造业', character: 'B1614', characterName: '食品、副食品加工厂' },
  { value: 'B31', text: '木竹制品及家具制造业', character: 'B0302', characterName: '木、竹制器具制造、加工、修理厂（有喷漆工作）' },
  { value: 'B32', text: '烟草制造业', character: 'B1611', characterName: '卷烟及雪茄烟厂' },
  { value: 'B33', text: '其它制造业', character: 'B9941', characterName: '打包分装厂' },
  { value: 'B34', text: '批发业', character: 'A0503', characterName: '批发、零售市场' },
  { value: 'B35', text: '零售业', character: 'A0433', characterName: '其他销售一般普通用品的小型商店' },
  { value: 'B36', text: '服务业', character: 'A0433', characterName: '其他销售一般普通用品的小型商店' },
  { value: 'B37', text: '农林渔牧及采矿业', character: 'B1706', characterName: '粮食加工厂' },
  { value: 'B38', text: '砂、石及黏土采取业', character: 'B0801', characterName: '工业用泥厂' },
  { value: 'B39', text: '其它矿业及土石采取业', character: 'B1807', characterName: '选矿厂' },
  { value: 'B40', text: '水电燃气供应业', character: 'A1001', characterName: '机房（消防、发电机、水电供应、蒸汽供应、空调）' },
  { value: 'B41', text: '建筑工程业', character: 'A0902', characterName: '工地' },
  { value: 'B42', text: '土木工程业', character: 'A0902', characterName: '工地' },
  { value: 'B43', text: '专门营造业', character: 'B9941', characterName: '打包分装厂' },
  { value: 'B44', text: '不动产开发及经营业', character: 'A0103', characterName: '公建' },
  { value: 'B45', text: '交通运输业', character: 'A0804', characterName: '铁道、公路、桥梁、隧道' },
  { value: 'B46', text: '运输辅助业', character: 'A0804', characterName: '铁道、公路、桥梁、隧道' },
  { value: 'B47', text: '仓储业', character: 'A0611', characterName: '公共仓储（一般物品）' }
];
